import { IInventoryPage } from '../../../inventory-page.interface';


export const UPLOAD_POD_AI_TEMPLATES_PAGE: IInventoryPage = {
	'route': '/upload/pod/ai-templates',
	'title': 'AI Templates',
	'uiReference': [
		'Name',
		'Notes',
		'Loading AI templates...',
		'Template library',
		'Use templates in Edit',
		'Template Workspace',
		'templates',
		'Details',
		'Name this template and leave useful context for future edits.',
		'Name is required',
		'Name must be unique',
		'Keywords',
		'Control the preferred, fill, and excluded words used by AI.',
		'Main Keywords',
		'Copy',
		'Workbench',
		'Minimum one keyword is required',
		'Fill Keywords',
		'Blacklist',
		'Merch By Amazon',
		'Add optional rules for Amazon listing generation.',
		'Example',
		"The base prompt is predefined by us. If you don't add any custom rules, it will look a lot like the example below.",
		'Input',
		'Output',
		'Custom Rules',
		'Input can not be empty',
		'Each entry must be unique',
		'Max chars allowed for custom rule',
		'Add Rule',
		'Global',
		'Define reusable rules for non-Amazon listing content.',
		'The max length for title and description is based on the global settings you defined for the edit. Limits of title and description will be applied.',
		'Input can not be duplicate',
		'Filter',
		'Create Custom AI Instructions',
		'Templates',
		'Add',
		'Edit Template',
		'Save',
		'Global Rules',
		'MBA Rules'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/pod-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/ai-templates/ai-templates.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/ai-templates/ai-templates.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/ai-templates/ai-templates.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.html'
	],
	'aliases': []
};
